import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import StoriesPage from "../pages/stories/page";
import StoryDetailPage from "../pages/story/page";
import TopicsPage from "../pages/topics/page";
import FaqPage from "../pages/faq/page";
import AboutPage from "../pages/about/page";
import SubmitPage from "../pages/submit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/stories",
    element: <StoriesPage />,
  },
  {
    path: "/story/:id",
    element: <StoryDetailPage />,
  },
  {
    path: "/topics",
    element: <TopicsPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/submit",
    element: <SubmitPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;